import { useContext } from 'react';

import { PaperworkDispatchContext, PaperworkStateContext } from './Provider';

export const usePaperworkDispatch = () =>
  useContext(PaperworkDispatchContext);

export const usePaperworkState = () =>
  useContext(PaperworkStateContext);
